// extracted by mini-css-extract-plugin
export default {"screen":"Screen_screen__EqtIw","divideByZero":"Screen_divideByZero__P-r0b","inputValue":"Screen_inputValue__Hznby","previouslyValue":"Screen_previouslyValue__TIFFy"};